<template>
	<section>
		<el-form inline style="margin:10 0">
			<el-form-item style="margin-bottom:0">
				<el-input type="text" placeholder="请输入搜索任务标题" v-model="optionValue" @input="findMission" clearable>
				</el-input>
			</el-form-item>
			<el-form-item style="margin-bottom:0">
				<el-button @click.native.prevent="openDia" type="primary">新建画册任务</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="tableData" style="width: 100%" v-loading="loading" height="65vh">
			<el-table-column align="left" width="60">
				<template slot-scope="scope">
					<div style="display:flex;align-items:center;">
						<el-popover placement="top-start" trigger="hover">
							<el-image slot="reference" style="width: 36px; height: 36px;" :src="scope.row.thumbnail"
								fit="cover" :preview-src-list="scope.row.arrayThum"></el-image>
							<el-image style="width: 236px; height: 236px;" :src="scope.row.thumbnail" fit="cover"
								:preview-src-list="scope.row.arrayThum"></el-image>
						</el-popover>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="title" label="任务标题"></el-table-column>
			<el-table-column prop="theme_name" label="画册标题"></el-table-column>
			<el-table-column prop="pay_type" :formatter="payTypeFormatter" label="支付方式"></el-table-column>
			<el-table-column prop="class_num" label="班级数" align="center"></el-table-column>
			<el-table-column prop="student_num" label="学生数" align="center"></el-table-column>
			<el-table-column label="采集数据范围" align="center">
				<template slot-scope="scope">{{scope.row.totalTime}}</template>
			</el-table-column>
			<el-table-column prop="add_time" :formatter="addTimeFormatter" label="发布时间" align="center">
			</el-table-column>
			<el-table-column prop="end_time" :formatter="formatter1" label="截止时间" align="center"></el-table-column>
			<el-table-column prop="statustext" label="状态" align="center">
				<template slot-scope="scope">
					<span :style="scope.row.status=='RECALL'?'color:red':''">{{scope.row.statustext}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="200">
				<template slot-scope="scope">
					<el-button @click.native.prevent="edit(scope.row)" type="text" size="large" class="button_color">修改
					</el-button>

					<el-button @click.native.prevent="toDetail(scope.row,type)" type="text" size="large"
						class="button_color" v-if="scope.row.status!='RECALL'">详情</el-button>

					<el-button @click.native.prevent="toSupple(scope.row)" type="text" size="large" class="button_color"
						v-if="scope.row.status!='RECALL'">补发</el-button>

					<el-button @click.native.prevent="rollBack(scope.row.id)" type="text" size="large"
						class="button_color" v-if="scope.row.status!='RECALL'">撤回</el-button>
					<el-button @click.native.prevent="deleteMission(scope.row.id)" type="text" size="large"
						class="button_color" v-if="scope.row.status=='RECALL'">删除</el-button>
					<!-- <el-button
                        @click.native.prevent="openDetail(scope.row)"
                        type="text"
                        size="large"
                        class="button_color"
                    >任务详情</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<el-row style="text-align:right;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="filters.currentPage" :page-sizes="[10,20,30,50,100]" :page-size="filters.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
		</el-row>
		<el-dialog title="任务设置" :visible.sync="dialogVisible" width="80%" :close="handleClose" top="5vh" class="dialog1"
			:close-on-click-modal="false">
			<!-- 主题列表 -->
			<theme-select ref="themeSelectRef" :is_check="true" :is_admin="false" @getCheckTheme="getCheckTheme"
				@openDrawer="openDrawer"></theme-select>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="openTheme">下 一 步</el-button>
			</span>
		</el-dialog>

		<el-dialog :visible.sync="dialogFormVisible1" v-loading="loading">
			<el-form :model="form" :rules="rule" ref="form">
				<el-form-item label="标题" label-width="100" prop="title">
					<el-input v-model="form.title" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="班级学生" label-width="100" prop="classValue">
					<el-button :type="student_ids.length>0?'':'primary'" @click="toSelectStudent()">
						{{student_ids.length>0?'已选'+student_ids.length+'人':'请选择'}}</el-button>
				</el-form-item>
				<!-- 数据采集范围 -->
				<el-form-item label="数据采集时间范围" label-width="100">
					<el-radio-group v-model="radio">
						<el-radio :label="3" @change="selectLabel">
							<el-date-picker v-model="startValue" type="daterange" start-placeholder="开始"
								end-placeholder="结束" @change="select(1)" :disabled="radio!=3?true:false"
								value-format="timestamp"></el-date-picker>
						</el-radio>
						<el-row style="margin-top:20px;">
							<el-radio :label="6" @change="selectLabel">
								从入园开始算，到
								<el-date-picker v-model="endTime" type="date" placeholder="选择日期" @change="select(2)"
									:disabled="radio!=6?true:false" value-format="timestamp"></el-date-picker>
							</el-radio>
						</el-row>
						<el-radio :label="9" @change="selectLabel">
							<el-select v-model="termValue" placeholder="选择学期，可多选" @change="select(3)"
								:disabled="radio!=9?true:false">
								<el-option v-for="item in termList" :key="item.id" :label="item.term" :value="item.id">
								</el-option>
							</el-select>
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="支付方式" label-width="100" >
					<el-select v-model="form.pay_type"  placeholder="">
						<el-option label="线上线下支付" :value="0" />
						<el-option label="仅线下支付" :value="1" />
						<el-option label="仅线上支付" :value="2" />
					</el-select>
				</el-form-item>
				<el-form-item label="截止时间" label-width="100" prop="endTime">
					<el-date-picker v-model="form.endTime" type="date" placeholder="结束时间" value-format="timestamp"
						:picker-options="startDatePicker1"></el-date-picker>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible1 = false">取 消</el-button>
				<el-button type="primary" @click="addMission('form')">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 指定选择学生 -->
		<select-students ref="selectStudentsRef" :checkIdsS="student_ids" @getCheckList="getCheckStudents"
			@cancelSelect="!mission_id?dialogFormVisible1=true:''"></select-students>
		<edit-mission-form v-if="editFormVisible" :mission="currentMission" @close="editFormVisible=false"
			@success="onEditSuccess" />
		<!-- <edit-theme-mission ref="themeRef" :is_edit="0"></edit-theme-mission> -->
	</section>
</template>
<script>
	import themeSelect from "@/components/book/themeSelect";
	import { schoolClass, term } from "@/api/server";
	import { book_mission } from "@/api/book";
	import formatter from "@/mixins/formatter";
	import selectStudents from "@/components/common/myClassStudents.vue";
	import EditMissionForm from './edit-mission-form.vue';
	import MissionStatusMixin from '../mission-status-mixin'
	export default {
		mixins: [formatter, MissionStatusMixin],

		data() {
			return {
				filters: {
					currentPage: 1,
					pageSize: 10
				},
				currentMission: {},
				editFormVisible: false,
				drawer: false,
				tableData: [],
				loading: false,
				theme_id: "",
				dateValue: "",
				classValue: [],
				school_id: "",
				dialogVisible: false,
				dialogFormVisible1: false,
				form: {
					title: "",
					endTime: ""
				},
				calss: [],
				studentNum: 0,
				rule: {
					title: [
						{
							required: true,
							message: "请输入任务标题",
							trigger: "blur"
						}
					],
					classValue: [
						{ required: true, message: "请选择班级", trigger: "blur" }
					],
					endTime: [
						{
							required: true,
							message: "请选择截止时间",
							trigger: "blur"
						}
					]
				},
				total: 0,
				obj: [],
				type: "1",
				optionValue: null,
				option: [],
				add_items: [],
				startValue: [],
				termList: "",
				termValue: null,
				flag: true,
				endTime: null,
				radio: 3,
				time_type: null,
				startDatePicker1: this.beginDate1(),

				student_ids: [],
				mission_id: null
			};
		},
		components: { themeSelect, selectStudents, EditMissionForm },
		methods: {
			// openDetail(data) {
			//     this.$refs.themeRef.open(data.theme_id);
			// },
			toSupple(data) {
				this.mission_id = data.id;
				this.$nextTick(r => {
					this.$refs.selectStudentsRef.openSelectUser();
				});
			},
			edit(data) {
				this.currentMission = data;
				this.editFormVisible = true

			},
			onEditSuccess() {
				this.editFormVisible = false
				this.getMission();

			},
			toSelectStudent() {
				this.dialogFormVisible1 = false;
				this.$nextTick(r => {
					this.$refs.selectStudentsRef.openSelectUser();
				});
			},
			getCheckStudents(val) {
				this.student_ids = val;
				if (this.mission_id) {
					this.$confirm("确定要补发吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					}).then(() => {
						let param = {
							mission_id: this.mission_id,
							student_ids: this.student_ids
						};
						book_mission.add(param).then(res => {
							if (res.data) {
								this.$message({
									message: "补发成功！",
									type: "success"
								});
								this.getMission();
							}
							this.student_ids = []
						});
					}).catch(() => { });
				} else {
					this.dialogFormVisible1 = true;
				}
			},
			beginDate1() {
				return {
					disabledDate(time) {
						return time.getTime() < Date.now();
					}
				};
			},
			selectLabel(val) {
				this.startValue = [];
				this.endTime = null;
				this.termValue = null;
			},
			select(val) {
				this.time_type = val;
			},
			getTerm() {
				term.getTerm()
					.then(res => {
						if (res.data) {
							this.termList = res.data.list;
						}
					})
					.catch();
			},

			findMission() {
				this.getMission();
			},
			formatter1(row) {
				return this.timeFormatter(row.end_time);
			},
			deleteMission(id) {
				this.$confirm(`确认删除吗?`, "提示", {
					type: "warning"
				})
					.then(() => {
						book_mission.delBookMission({ id: id }).then(res => {
							if (res.code == 0) {
								this.$message({
									message: "删除成功",
									type: "success"
								});
								this.getMission();
							}
						});
					})
					.catch(() => { });
			},

			handleSizeChange(newValue) {
				this.filters.pageSize = newValue;
				this.filters.currentPage = 1;
				this.getMission();
			},
			handleCurrentChange(newValue) {
				this.filters.currentPage = newValue;
				this.getMission();
			},
			deleteRow() {
				this.$router.push("/book/bookmanage/detail");
			},
			openDia() {
				this.add_items = [];
				this.dialogVisible = true;
				this.theme_id = null;
				this.student_ids = [];
				this.mission_id = null;
				this.$nextTick(r => {
					this.$refs.themeSelectRef.clearCheck();
				});
			},
			getCheckTheme(theme_id) {
				//选中的主题id
				this.theme_id = theme_id;
			},
			openTheme() {
				if (!this.theme_id) {
					this.$message({ message: "未选择主题", type: "error" });
					return;
				}
				this.dialogVisible = false;
				this.$refs.themeSelectRef.openTheme(this.theme_id);
			},
			openDrawer(items) {
				this.add_items = items;
				this.dialogVisible = false;
				this.dialogFormVisible1 = true;
				this.$nextTick(_ => {
					this.$refs["form"].resetFields();
				});
			},
			handleClose() {
				this.drawer = false;
			},
			getClass() {
				this.calss = [];
				schoolClass.findClassByRole().then(res => {
					if (res.code == 0) {
						if (res.data && res.data.length > 0) {
							this.calss = res.data;
							this.school_id = res.data[0].school_id;
							res.data.forEach(e => {
								let temp = {
									id: e.id,
									num: e.total
								};
								this.obj.push(temp);
							});
						}
					}
				});
			},
			changeValue(val) {
				this.studentNum = 0;
				for (var i = 0; i <= val.length - 1; i++) {
					for (var k = 0; k <= this.obj.length - 1; k++) {
						if (this.obj[k].id == val[i]) {
							this.studentNum = this.obj[k].num + this.studentNum;
						}
					}
				}
			},
			addMission(formName) {
				if (!this.form.title) {
					this.$message.error("请输入标题");
					return;
				}
				if (this.student_ids.length < 1) {
					this.$message.error("请选择班级学生！");
					return;
				}

				if (!this.form.endTime) {
					this.$message.error("请选择截止时间！");
					return;
				}

				if ((!this.startValue || this.startValue.length == 0) && !this.endTime && !this.termValue) {
					this.$message.error("请选择数据时间范围")
					return;
				}

				this.loading = true;
				let params = {
					title: this.form.title,
					school_class: this.classValue,
					end_time:
						this.form.endTime == 0 ? null : this.form.endTime / 1000,
					theme_id: this.theme_id,
					school_id: this.school_id,
					item: this.add_items,
					time_type: this.time_type,
					data_start_time:
						this.startValue == [] ? null : this.startValue[0] / 1000,
					data_end_time:
						this.startValue == [] ? null : this.startValue[1] / 1000,
					student_time: this.endTime / 1000,
					term_id: this.termValue,
					student_ids: this.student_ids,
					pay_type:this.form.pay_type||0
				};
				book_mission.addMission(params).then(res => {
					this.dialogFormVisible1 = false;
					this.getMission();
					this.loading = false;
					this.student_ids = []
				});
			},
			getMission() {
				let params = {
					currentPage: this.filters.currentPage,
					pageSize: this.filters.pageSize,
					title: this.optionValue
				};
				this.loading = true;
				book_mission.getMission(params).then(res => {
					this.loading = false;
					if (res.data) {
						res.data.list.forEach(e => {
							if (e.status == "ING_TIME") {
								e.statustext = "进行中";
							} else if (e.status == "CUT_TIME") {
								e.statustext = "已截止";
							} else if (e.status == "RECALL") {
								e.statustext = "已撤回";
							}
							if (e.data_start_time != null) {
								e.data_start_time = this.timeFormatter(
									e.data_start_time
								);
							}
							if (e.data_end_time != null) {
								e.data_end_time = this.timeFormatter(
									e.data_end_time
								);
							}
							if (e.data_student_time != null) {
								e.data_student_time = this.timeFormatter(
									e.data_student_time
								);
							}
							if (e.time_type == 1) {
								e.totalTime =
									e.data_start_time + " 至 " + e.data_end_time;
							} else if (e.time_type == 2) {
								e.totalTime =
									"从入园开始算，到" + e.data_student_time;
							} else if (e.time_type == 3) {
								e.totalTime = e.term_name;
							}
							e.arrayThum = [];
							e.arrayThum.push(e.thumbnail);
						});
						this.tableData = res.data.list ? res.data.list : [];
						this.total = res.data.totalRow;
					}
					this.loading = false;
				});
			},

			toDetail(row, type) {

				this.$router.push({
					path: "/book/bookmanage/detail",
					query: { id: row.id, type: type, tag: row.title }
				});
			},
			rollBack(id) {
				this.$confirm(`确认撤回吗?`, "提示", {
					type: "warning"
				}).then(() => {
					book_mission.rollBack({ id: id }).then(res => {
						if (res.code == 0) {
							this.getMission();
							this.$message.success("撤回成功");
						}
					});
				}).catch(() => { });
			}
		},
		created() {
			this.getClass();
			this.getMission();
			this.getTerm();
		}
	};
</script>
<style lang="scss" scoped>
	.dialog1 /deep/ .el-dialog__body {
		padding: 0 20;
	}
</style>



// WEBPACK FOOTER //
// src/views/book/bookmanage/index.vue